import React, { useEffect, useState } from 'react';
import * as monthUtils from 'loot-core/shared/months';
import { monthsOfCalendarYear } from 'loot-core/shared/months';
import { theme } from '../../style';
import { Button } from '../common/Button';
import { Select } from '../common/Select';
import { Text } from '../common/Text';
import { Setting } from './UI';
import { useGlobalPref } from '../../hooks/useGlobalPref';
import { SettingColumn } from './SettingColumn';

export function FiscalYearStart({ isHighLighted }) {
  const [fiscalYearStart, setFiscalYearStart] = useGlobalPref('fiscalYearStart');
  const months = monthsOfCalendarYear(new Date().getFullYear());
  const [highLighted, setHighLighted] = useState(false);

  useEffect(() => {
    if (isHighLighted) {
      setHighLighted(true);
      setTimeout(() => {
        setHighLighted(false);
      }, 500);
    }
  }, []);

  return (
    <Setting
      style={{
        transition: 'background-color 0.4s linear',
        ...(highLighted
          ? { backgroundColor: theme.menuAutoCompleteBackgroundHover }
          : {}),
      }}
      primaryAction={
        <SettingColumn title="Month">
          <Button bounce={false} style={{ padding: 0 }}>
            <Select
              bare
              options={months.map(m => [
                m.index + '',
                monthUtils.format(m.month, 'MMMM'),
              ])}
              style={{ minWidth: 100 }}
              value={fiscalYearStart + ''}
              defaultLabel="Select an option"
              onChange={async option => {
                setFiscalYearStart(+option);
              }}
            />
          </Button>
        </SettingColumn>
      }
    >
      <Text>Please select the month that marks the beginning of your <b>fiscal year</b>.</Text>
    </Setting>
  );
}
